export default {
  description: function description(state) {
    return state.description;
  },
  products: function products(state) {
    return state.products;
  },
  suggestions: function suggestions(state) {
    return state.suggestions;
  },
  productsCount: function productsCount(state) {
    return state.total;
  },
  provider: function provider(state) {
    return state.provider;
  }
};